import request from '@/utils/request'

// 查询入驻审核列表
export function pageWorker(data) {
  return request({
    url: '/homeservice/worker/page',
    method: 'post',
    data: data
  })
}

// 查询入驻审核详情
export function getWorker(id) {
  return request({
    url: '/homeservice/worker/detail',
    method: 'get',
    params: { id }
  })
}

// 入驻审核
export function auditWorker(data) {
  return request({
    url: '/homeservice/worker/audit',
    method: 'post',
    data: data
  })
}
